// Client Portal sign-in. Passwordless: the customer enters their email, we send a one-time 6-digit code, they type it
// here. The page itself is the shared CodeSignIn (Session ATA lifted it out unchanged so the Subcontractor Portal signs
// in the same way); read its header for the deep link, the resend clock and the anti-enumeration wording.
import { api } from "../../lib/api";
import { CodeSignIn } from "./CodeSignIn";

export function PortalLogin() {
  return (
    <CodeSignIn
      productName="Client Portal"
      destination="/portal"
      requestCode={(email) => api.portal.requestCode(email)}
      verifyCode={(email, code) => api.portal.verifyCode(email, code)}
      idPrefix="portal"
    />
  );
}
